import { handleLoading, handleErrors } from './../helpers'

const state = () => ({
	passwordReset: {
		done: false
	},
	activation: {
		message: null,
		passed: false
	}
})

const actions = {
	register({ commit }, { payload, context, loading }) {
		handleLoading(context, loading)
		handleErrors(context, null)

		return axios.post('/auth/register', payload.value).then(response => {
			handleLoading(context, loading)

			return Promise.resolve(response)
		}).catch(error => {
			handleErrors(context, error.response.data.data)
			handleLoading(context, loading)

			return Promise.reject(error)
		})
	},

	login({ commit }, { payload, context, loading }) {
		handleLoading(context, loading)
		handleErrors(context, null)

		return axios.post('/auth/login', payload.value).then(response => {
			return Promise.resolve(response)
		}).catch(error => {
			handleErrors(context, error.response.data.data)
			handleLoading(context, loading)

			return Promise.reject(error)
		})
	},

	passwordReset({ commit }, { payload, context, loading }) {
		handleLoading(context, loading)
		handleErrors(context, null)
		commit('setPasswordResetDone', false)

		return axios.post('/auth/password', payload).then(response => {
			handleLoading(context, loading)

			commit('setPasswordResetDone', true)

			return Promise.resolve(response)
		}).catch(error => {
			handleErrors(context, error.response.data.data)
			handleLoading(context, loading)

			return Promise.reject(error)
		})
	},

	activate({ commit }, code) {
		return axios.post('/auth/activate-account/' + code).then(response => {
			commit('setActivation', {
				passed: true,
				message: response.data.data.message
			})
		}).catch(error => {
			commit('setActivation', {
				passed: false,
				message: error.response.data.data.message
			})
		})
	}
}

const mutations = {
	setPasswordResetDone(state, done) {
		state.passwordReset.done = done
	},

	setActivation(state, { message, passed }) {
		state.activation.message = message
		state.activation.passed = passed
	}
}


export default {
	state,
	actions,
	mutations
}
